var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "vuetextareatag", staticClass: "vue-text-area-tag" },
    [
      _c("div", { staticClass: "wrapper", class: { active: _vm.active } }, [
        !_vm.active
          ? _c("div", {
              staticClass: "text-area-content",
              class: { active: _vm.active },
              domProps: { innerHTML: _vm._s(_vm.renderValue) }
            })
          : _vm._e()
      ]),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy.trim",
            value: _vm.displayValue,
            expression: "displayValue",
            modifiers: { lazy: true, trim: true }
          }
        ],
        class: { active: _vm.active },
        attrs: { rows: _vm.rows, cols: _vm.cols, maxlength: _vm.maxlength },
        domProps: { value: _vm.displayValue },
        on: {
          focusin: _vm.isActive,
          focusout: _vm.isInActive,
          change: function($event) {
            _vm.displayValue = $event.target.value.trim()
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }